import ResourcesPagination from "./ResourcesPagination";

export default ResourcesPagination;
